import { sortByName } from '../helpers'

export default function (axios, api) {
  return {
    state: {
      dabgPublicKey: '',
      elections: [],
      election: {
        title: {
          rendered: null
        },
        background: { url: false },
        rules: '',
        candidates: '',
        questionnaire: []
      },
      currentElectionSlug: false,
      provinces: [],
      places: []
    },

    getters: {
      elections: state => state.elections,
      election: state => state.election,
      electionBg: state => state.election.background.url,
      currentElectionSlug: state => state.currentElectionSlug,
      provinces: state => state.provinces,
      places: state => state.places,
      dabgPublicKey: state => state.dabgPublicKey
    },

    actions: {
      getElections ({ commit }) {
        return api.fetchElections().then(elections => {
          commit('setElections', elections)
        })
      },

      getElection ({ commit }, slug) {
        commit('clearTabs')
        return api.fetchElection(slug).then(election => {
          let tabs = []

          if (election.registration_required && election.registration_open) {
            tabs.push({ title: 'Регистрация', link: { name: 'election-registration', params: { slug } } })
          }

          if (election.rules.length > 0) {
            tabs.push({ title: 'Правила', link: { name: 'election-rules', params: { slug } } })
          }

          if (election.candidates_new.length > 0 || election.candidates.length > 0) {
            tabs.push({ title: 'Кандидати', link: { name: 'election-candidates', params: { slug } } })
          }

          if (election.questionnaire.length > 0) {
            tabs.push({ title: 'Гласуване', link: { name: 'election-voting', params: { slug } } })
          }

          commit('setTabs', tabs)
          commit('setElection', election)
          commit('setTitle', election.title.rendered)
        })
      },

      getCurrentElection ({ commit }) {
        return api.fetchCurrentElection().then(election => {
          commit('setCurrentElectionSlug', election)
        })
      },

      checkOwnRegistration ({ state }) {
        return api.checkOwnRegistrationFor(state.election.id)
      },

      getProvinces ({ commit }) {
        return api.fetchProvinces().then(provinces => {
          commit('setProvinces', provinces.sort(sortByName))
        })
      },

      getPlacesInProvince ({ commit }, province) {
        return api.fetchPlacesInProvince(province).then(places => {
          commit('setPlaces', places.sort(sortByName))
        })
      },

      submitElectionRegistration ({ state }, user) {
        return api.registerUserForElection(user, state.election.id)
      },

      confirmElectionRegistration ({ state }, token) {
        return api.confirmElectionRegistration(state.election.id, token)
      },

      getPublicKey ({ commit }) {
        return new Promise((resolve, reject) => {
          api.getPublicKey('dabg').then(response => {
            commit('setPublicKey', response.data.key)
            resolve(response)
          }).catch(err => reject(err.response.data))
        })
      },

      getOwnPublicKey () {
        return api.getPublicKey('own')
      },

      uploadOwnPublicKey (_, key) {
        return api.uploadOwnPublicKey(key)
      },

      vote (_, vote) {
        return api.vote(vote)
      },

      getOwnVote (_, electionId) {
        return api.getOwnVote(electionId)
      }
    },

    mutations: {
      setPublicKey (state, key) {
        state.dabgPublicKey = key
      },

      setElections (state, elections) {
        state.elections = elections
      },

      setElection (state, election) {
        state.election = election
      },

      setProvinces (state, provinces) {
        state.provinces = provinces
      },

      setPlaces (state, places) {
        state.places = places
      },

      setCurrentElectionSlug (state, election) {
        state.currentElectionSlug = decodeURIComponent(election.post_name)
      }
    }
  }
}
